import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadNotificationTemplateByIdFailed, loadNotificationTemplateByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadNotificationTemplateById(action) {
  try {
    const url = `${BACKEND_URL}/resources/notification-templates/${action.payload}`;
    yield call(resolveActionPromise(action));
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadNotificationTemplateByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadNotificationTemplateByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadNotificationTemplateByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
